export default {
  SET_RATES: (state, { rate, list }) => {
    state.rates[rate] = list;
  },
};
